/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/named
import { API_EVENTS, STAFF_PAYRATES_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
};

const staffPayratesReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
    case STAFF_PAYRATES_EVENTS.REMOVE_REQUEST:
    case 'DELETE_INC_REQ':
      return { ...state, loading: true };

    case API_EVENTS.FAIL:
    case STAFF_PAYRATES_EVENTS.REMOVE_FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      return { ...state, loading: false, data: payload };

    case STAFF_PAYRATES_EVENTS.REMOVE_SUCCESS:
      if (payload.staffType === '1') {
        return {
          ...state,
          loading: false,
          data: {
            ...state.data,
            manager: state.data.manager.filter((x) => x.payRateId !== payload.id),
          },
        };
        // eslint-disable-next-line no-else-return
      } else if (payload.staffType === '2') {
        return {
          ...state,
          loading: false,
          data: {
            ...state.data,
            employee: state.data.employee.filter((x) => x.payRateId !== payload.id),
          },
        };
      } else if (payload.staffType === '3') {
        return {
          ...state,
          loading: false,
          data: {
            ...state.data,
            instructor: state.data.instructor.filter((x) => x.payRateId !== payload.id),
          },
        };
      }
      return { ...state };

    case 'DELETE_INC_SUCC':
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default staffPayratesReducer;
